// extracted by mini-css-extract-plugin
export default {"taskPriorityCellRoot":"taskPriorityCellRoot--d7m9H"};